import { IAgathaBlock } from "@/home/TeacherHomepage/types/IAgathaBlock";

import { QueryParams } from "@/api";

interface PersonalPageFilter extends QueryParams {
  version?: string;
  block_id?: string;
  max_content_list_length?: string;
}

export const personalPageFilterMock: PersonalPageFilter = {
  version: "home-v2",
};

type PersonalPageResponse = {
  block_type: string;
  generating_service: {
    name: string;
    sha: string;
    version: string;
  };
  generation_date: string;
  members: IAgathaBlock[];
  page_id: string;
  page_type: string;
  parameters: Record<string, unknown>;
  request_type: string;
  response_id: string;
  service_metadata: Record<string, unknown>;
  status: number;
};

export const personalPageMock: PersonalPageResponse = {
  block_type: "api_response",
  generating_service: {
    name: "Agatha",
    sha: "",
    version: "",
  },
  generation_date: "20241202T1815222Z",
  members: [
    {
      block_id: "root",
      block_sibling_index: 0,
      block_type: "page",
      members: [
        {
          block_id: "featured",
          block_sibling_index: 1,
          block_type: "content_list",
          content_id: "ckcxom7y900003g5nwt1gbtgy",
          members: [],
          slug: "featured-row-hp",
          title: "Featured",
        },
        {
          block_id: "recent-video",
          block_sibling_index: 2,
          block_type: "content_list",
          members: [],
          style_hints: {
            list_style: "hp_video_list_style_enabled",
          },
          title: "Latest videos",
        },
      ],
      title: "Welcome to Newsela!",
    },
  ],
  page_id: "home",
  page_type: "personal-page",
  parameters: {
    admin_content_settings: null,
    api_key: null,
    block_id: "root",
    conset_group_ids: null,
    content_id: null,
    content_maturities: "",
    content_types: [
      "articleheader",
      "interactivevideolink",
      "textset",
      "externallink",
    ],
    debug: false,
    dynamic_formative: false,
    features: [],
    filter_controls: null,
    genre: null,
    grade_level: null,
    grant_sets: [
      "available-as-unauthenticated-user",
      "development-test-data",
      "ela",
      "essentials",
      "lite",
      "sci",
      "ss",
    ],
    grants: [],
    hide_sets: ["consetnot-in-trial"],
    hides: [],
    instructional_features: [],
    language: "en",
    lexile_level_range: null,
    max_content_list_length: 10,
    optimizely_attributes: {
      $opt_bucketing_id: "2000287764",
      activeELALicense: true,
      activeEssentialsLicense: false,
      activeSSLicense: true,
      activeScienceLicense: true,
      classroom_ids_csv: "",
      district_ids_csv: "ae29ef06d5544b20898ac0669e7d3206",
      group_ids_csv: "",
      isAdmin: false,
      isFreeUser: false,
      isStaff: false,
      isStudent: false,
      isSubscription: true,
      isTeacher: true,
      isTrialUser: true,
      is_authenticated: true,
      preferred_school_id: "2278ecb181ff49c7b075f80feb14f757",
      schoolId: "2000287764",
      social_auths_csv: "",
      state: "AL",
      subjects_grades_csv: "",
      userId: "dda89fbdf4bf45cc8681c64ab637a360",
    },
    reading_skills: null,
    related_to_standards: null,
    tags: [],
    taxonomy_slug: [],
    taxonomy_tags: null,
    user_attributes: {
      active_licenses: [
        {
          is_trial: true,
          product: "ela",
        },
        {
          is_trial: true,
          product: "social_studies",
        },
        {
          is_trial: true,
          product: "science",
        },
      ],
      actual_grade: 8,
      classroom_subject_grades: {},
      combined_subjects: [],
      content_maturities: [],
      district_ids: ["ae29ef06d5544b20898ac0669e7d3206"],
      features: {
        can_access_promoted_at_your_district_page: "on",
        can_access_reading_skills_report: "on",
        can_access_usage_report: "on",
        can_create_classrooms: "on",
        can_manage_their_roles: "on",
        can_onboard: "on",
        can_see_everwrite: "on",
        can_see_formative: "on",
        can_see_ai_features: "on",
        can_view_irc: "on",
        can_view_search: "on",
        can_view_their_licenses: "on",
        create_canvas_assignments: "on",
        create_custom_text_sets: "on",
        create_custom_write_prompts: "on",
        has_access_to_lite: "on",
        has_active_premium_trial: "on",
        has_active_premium_trial_campaign: "on",
        has_ela_license: "on",
        has_science_license: "on",
        has_social_studies_license: "on",
        is_demo_user: "on",
        is_educator: "on",
        is_school_educator: "on",
        is_teacher: "on",
        lock_article_level: "on",
        view_administrator_binder: "on",
        view_educator_binder: "on",
        view_power_words: "on",
      },
      grade_level: 8,
      group_ids: [],
      in_district_with_all_advisory_content: false,
      is_authenticated: true,
      is_demo: true,
      is_staff: false,
      preferred_school_id: "2278ecb181ff49c7b075f80feb14f757",
      preferred_school_pk: 2000287764,
      school_ids: ["2278ecb181ff49c7b075f80feb14f757"],
      social_auth_providers: [],
      state: "AL",
      teacher_subjects: [],
      user_id: "dda89fbdf4bf45cc8681c64ab637a360",
      user_pk: 931,
      user_roles: ["teacher"],
    },
    user_id: "dda89fbdf4bf45cc8681c64ab637a360",
    veils: [],
    version_tag: null,
  },
  request_type: "personal-page",
  response_id: "cm47e0jex000n66n46nlw4fya",
  service_metadata: {},
  status: 200,
};
